import React from 'react';
import { mockHeroData } from '../data/mockData';
import '../styles/HeroSection.css';

const HeroSection = () => {
  return (
    <section id="overview" className="hero-section">
      <div className="hero-container">
        <div className="hero-left">
          <h1 className="hero-title">OVERVIEW</h1>
          <div className="hero-contact">
            <a href={`mailto:${mockHeroData.email}`} className="hero-email">
              {mockHeroData.email}
            </a>
          </div>
        </div>
        
        <div className="hero-right">
          <ul className="hero-list">
            {mockHeroData.capabilities.map((item, index) => (
              <li key={index} className="hero-list-item">
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
      
      <div className="experience-badge">
        <div className="experience-number">{mockHeroData.experience}</div>
        <div className="experience-text">YEARS OF<br />EXPERIENCE</div>
        <div className="experience-subtitle">Industry Expert</div>
      </div>
    </section>
  );
};

export default HeroSection;